import React from 'react';
// Data
import { CompanyName, CompanyTagLine, MainTitle } from '../../utils/Constants';

function AltHeader() {
  return (
    <article className='grid w-full h-fit bg-banner-eyes bg-no-repeat bg-center bg-cover z-10 mt-12 lg:mt-16'>
      <div className='grid gap-y-4 bg-colour1/60 py-8 h-fit text-center justify-center items-center'>
        <div>
          <h2 className='text-sm lg:text-2xl uppercase -mb-1'>{MainTitle}</h2>
        </div>
        <div>
          <h1 className='text-[2.5rem] lg:text-8xl font-titleFont'>{CompanyName}</h1>
        </div>
        <div>
          <h3 className='-mt-1 uppercase lg:text-xl'>{CompanyTagLine}</h3>
        </div>
      </div>
    </article>
  );
}

export default AltHeader;
